/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;color:#000}[_nghost-%COMP%]   .icon-icon[_ngcontent-%COMP%]{fill:var(--fill-color);width:45px;height:45px;margin-bottom:5px;margin-top:15px}[_nghost-%COMP%]   .section-title[_ngcontent-%COMP%]{font-size:1.3em;font-weight:500;margin-bottom:6px}[_nghost-%COMP%]   .section-desc[_ngcontent-%COMP%]{color:#515151;font-size:1.1em;margin-bottom:20px;font-weight:300}"];
export { styles as styles };
